import { render, staticRenderFns } from "./roomTotal.vue?vue&type=template&id=0aef1f60&scoped=true"
import script from "./roomTotal.vue?vue&type=script&lang=js"
export * from "./roomTotal.vue?vue&type=script&lang=js"
import style0 from "./roomTotal.vue?vue&type=style&index=0&id=0aef1f60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef1f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aef1f60')) {
      api.createRecord('0aef1f60', component.options)
    } else {
      api.reload('0aef1f60', component.options)
    }
    module.hot.accept("./roomTotal.vue?vue&type=template&id=0aef1f60&scoped=true", function () {
      api.rerender('0aef1f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/roomTotal.vue"
export default component.exports